module.exports = __webpack_public_path__ + "public/img/icon_address.71bd0346.png";